// React Lib
import React from "react";
import classnames from 'classnames';
// Component Styles
import { useStyles } from "./IconButtonStyles";
import { Tooltip } from '../index';
import { Sandbox } from "../../icons";
export const IconButton = (props) => {
    const classes = useStyles(props);
    const { id, color, disabled, icon, style, textTooltip, onClick } = props;
    const buttonClasses = classnames({
        [classes.iconButton]: true,
        [classes[color]]: color,
        [classes.disabled]: disabled,
    });
    return (React.createElement(Tooltip, { title: textTooltip, enterNextDelay: 1000, leaveDelay: 200 },
        React.createElement("div", { id: id, className: buttonClasses, style: style, onClick: onClick }, icon)));
};
IconButton.defaultProps = {
    color: "primary",
    icon: React.createElement(Sandbox, null),
    textTooltip: 'Tooltip',
    disabled: false,
    onClick: () => { }
};
export default React.memo(IconButton);
